import { useEffect, useState } from "react";
import myApi from "../../apis/myApi";

// The coins a student holds, for the header: asked for on every page so it
// is never a sale or a lesson behind. The last answer is kept in this
// browser so the coins paint at once on the next page, and so a count that
// has changed since they last looked can turn its coin over. Without
// storage (a private window) the coins simply arrive a moment later and
// nothing turns.

const read = (key) => {
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};
const write = (key, value) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    // The header works without it.
  }
};
const idOf = (coin) => coin.id || "lessons";

const useLessonCoins = (user) => {
  const student = !!(user && user.id && user.role === "student");
  const key = student ? `swyvel:lesson-coins:${user.id}` : null;
  const [state, setState] = useState(() => (key && read(key)) || { coins: [], collected: 0 });
  const [changed, setChanged] = useState({});

  useEffect(() => {
    if (!student) return;
    myApi
      .coins()
      .then((res) => {
        const next = { coins: (res && res.coins) || [], collected: (res && res.collected) || 0 };
        const before = read(key);
        if (before) {
          const was = Object.fromEntries((before.coins || []).map((c) => [idOf(c), c.left]));
          setChanged(Object.fromEntries(next.coins.filter((c) => was[idOf(c)] !== c.left).map((c) => [idOf(c), true])));
        }
        write(key, next);
        setState(next);
      })
      .catch(() => {});
  }, []);

  const left = state.coins.reduce((sum, c) => sum + c.left, 0);
  return { coins: state.coins, collected: state.collected, left, changed, idOf };
};

export default useLessonCoins;
